:host {
  display: inline-block;

  &[disabled]:not([disabled="false"]) {
    --description-color: #{$formDisabledColor};
  }
}

.stzh-checkbox {
  @include input-description;
  display: grid;

  &__field-wrapper {
    @include fontSize('milli');
    position: relative;
    display: flex;
    user-select: none;
    cursor: pointer;
  }

  &__input {
    @include visuallyhiddenInput;
    border-radius: $formInputBorderRadius;
  }

  &__mark {
    border: 2px solid $colorBlack;
    background-color: $colorWhite;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: $formInputBorderRadius;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: border-color $baseTransitionAnimationSpeed;
  }

  &__check {
    display: flex;
    flex-direction: column;
    justify-content: center;
    opacity: 0;
    color: $colorPrimary;
    transition-property: color;
    transition-duration: $baseTransitionAnimationSpeed;
  }

  &__label {
    --stzh-base-color: initial;

    display: inline-block;
    color: $baseColor;
    transition: color $baseTransitionAnimationSpeed;
    margin-left: space('small');
    line-height: 24px;

    &:empty {
      display: none;
    }
  }

  &__marker {
    @include fontSize('micro');
    margin-left: calc(-0.25em + #{space('xsmall')});
  }

  /* Hover / Focus / Checked */

  &:hover &__label,
  &__input:checked ~ &__label {
    color: $colorPrimary70;
  }

  &__input:checked:hover ~ &__label,
  &__input:checked:hover ~ &__mark &__check {
    color: $colorPrimary90;
  }

  &:hover &__mark,
  &__input:checked ~ &__mark {
    border-color: $colorPrimary70;
  }

  &__input:checked:hover ~ &__mark {
    border-color: $colorPrimary90;
  }

  &__input:checked ~ &__mark &__check {
    opacity: 1;
  }

  /* Invalid */

  &--is-invalid &__input ~ &__label,
  &--is-invalid &__input ~ &__mark &__check {
    color: $colorError60;
  }

  &--is-invalid &__input ~ &__mark {
    border-color: $colorError60;
  }

  /* Disabled */

	&--is-disabled &__field-wrapper {
    cursor: not-allowed;
  }

  &--is-disabled &__input ~ &__label {
    color: $colorGrey60;
  }

  &--is-disabled &__input ~ &__mark &__check {
    color: $colorGrey50;
  }

  &--is-disabled &__input ~ &__mark {
    border-color: $colorGrey50;
  }

  &--is-disabled &__mark {
    background-color: $colorGrey20;
  }
}
